module.exports = __webpack_public_path__ + "img/green.743c9c07.svg";